const badges = [
  {
    src: "https://assets.cdn.filesafe.space/LybUg0eKBAfPYJVWJI73/media/6a704f36188345b27e9c5836.png",
    alt: "IMDT Accreditation",
  },
  {
    src: "https://assets.cdn.filesafe.space/LybUg0eKBAfPYJVWJI73/media/6a70532a188345b27ea64255.webp",
    alt: "IMDT Trainer",
  },
  {
    src: "https://assets.cdn.filesafe.space/LybUg0eKBAfPYJVWJI73/media/6a70532a188345b27ea64250.webp",
    alt: "Dog Training College",
  },
  {
    src: "https://assets.cdn.filesafe.space/LybUg0eKBAfPYJVWJI73/media/6a70532aa4c8a1a2c327fa9f.webp",
    alt: "World Scent Dog Association",
  },
  {
    src: "https://assets.cdn.filesafe.space/LybUg0eKBAfPYJVWJI73/media/6a70532aa4c8a1a2c327faa9.webp",
    alt: "School of Canine Science",
  },
  {
    src: "https://assets.cdn.filesafe.space/LybUg0eKBAfPYJVWJI73/media/6a70532aa4c8a1a2c327faa4.webp",
    alt: "Distinctive Dog Trainer",
  },
];

const AccreditationBadges = () => {
  return (
    <section className="bg-white py-6 border-y border-border/40">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid grid-cols-3 md:grid-cols-6 gap-3 md:gap-6 items-center justify-items-center">
          {badges.map((badge, idx) => (
            <img
              key={idx}
              src={badge.src}
              alt={badge.alt}
              className="h-12 md:h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
              loading="lazy"
              decoding="async"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AccreditationBadges;
